<script setup lang="ts">
import { ref } from "vue";

const svg = ref();
defineExpose({
  svg,
});
</script>
<template>
  <svg
    ref="svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9582 5.29537L16.1379 2.69762C16.4041 2.38031 16.8772 2.33892 17.1945 2.60518C17.5118 2.87144 17.5532 3.34451 17.2869 3.66182L15.1072 6.25967C16.1298 7.56824 16.1361 9.45683 15.0258 10.7801L14.5236 11.3786L12.3513 17.5324C12.0367 18.4236 11.0372 18.8456 10.2165 18.3769C9.18597 17.7882 7.75336 16.8746 6.26747 15.6278C6.04094 15.4377 5.82225 15.2475 5.6116 15.0584C5.57368 15.0243 5.53992 14.9875 5.51031 14.9485C5.33917 14.7229 5.30696 14.4241 5.41367 14.1672C5.45009 14.0795 5.50268 13.9967 5.57145 13.9234L7.68772 11.6669L5.07782 13.4604L4.97607 13.5303C4.69417 13.724 4.32612 13.7186 4.0577 13.5256C4.01709 13.4964 3.97876 13.4629 3.94336 13.4252C3.88347 13.3613 3.82477 13.2982 3.76727 13.2357C3.42734 12.8664 3.12923 12.5223 2.8749 12.2164C2.27077 11.4896 2.51247 10.4314 3.33545 9.96685L9.01768 6.75919L9.52027 6.1602C10.6307 4.83679 12.4919 4.5151 13.9582 5.29537ZM10.6693 7.1244L10.408 7.43579L13.6155 10.1273L13.8767 9.81587C14.6199 8.93013 14.5044 7.60959 13.6187 6.86637C12.733 6.12314 11.4125 6.23866 10.6693 7.1244ZM7.16208 14.4201L8.78179 12.6931C9.30581 12.1343 9.32465 11.2705 8.82549 10.6894C8.32633 10.1084 7.46955 9.99679 6.83823 10.4306L4.62645 11.9505C4.41489 11.7141 4.22343 11.4914 4.05278 11.2868C4.05767 11.2827 4.06417 11.278 4.0728 11.2731L9.19898 8.37936L12.8964 11.482L10.9369 17.033C10.9336 17.0423 10.9301 17.0496 10.9269 17.0551C9.95638 16.4987 8.61692 15.6411 7.23162 14.4787L7.16208 14.4201Z"
      fill="#747474"
    />
  </svg>
</template>
